import React from 'react'
import classes from './contactus.module.css'

export default function ContactUs() {
    return (
        <section className={classes.section}>
            <div className={classes.tittleContainer}>
                <h1 className={classes.title}>
                    Who we are:
                </h1>
                <p className={classes.description}>
                    Yuka LLC is a U.S.-based Limited Liability Company (LLC) specializing in the global distribution of high-quality coatings. Our commitment to excellence and innovation enables us to provide solutions tailored to the specific needs of each client, ensuring durable and aesthetically superior products for projects across various sectors worldwide.
                </p>
            </div>
            <div className={classes.infoContainer}>
                <p className={classes.p}>Contact:</p>
                <p className={classes.p}>comex@yukallc.com</p>
            </div>
            <div className={classes.infoContainer}>
                <p className={classes.p}>Adress:</p>
                <p className={classes.p}>16192 Coastal Highway, Lewes, Delaware (19958). EE.UU.</p>
            </div>
            <div>
                <p className={classes.p}>ID TAX:</p>
                <p className={classes.p}>36-5027616</p>
            </div>
        </section>
    )
}
